import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Drawer from '@material-ui/core/Drawer';
import Conversation from '../../../components/messaging/conversation/Conversation';

const styles = theme => ({
  dialogContainer: {
    textAlign: 'center'
  },
  buttonContainer: {
    marginTop: '50px'
  },
  cancelButton: {
    float: 'left'
  },
  confirmButton: {
    float: 'right',
    color: 'white'
  },
  list: {
    width: 550,
    [theme.breakpoints.down('xs')]: {
      width: 350
    }
  }
});

class MessageDrawer extends Component {
  componentWillMount() {
    const gg = 5;
  }

  componentWillReceiveProps(nextProps) {
    const gg = 5;
  }

  render() {
    const { classes, auth, sendTo, isOpen, onClose } = this.props;

    return (
      <React.Fragment>
        <Drawer onClose={onClose} anchor="right" open={isOpen}>
          <div className={classes.list} role="presentation">
            {isOpen && (
              <Conversation
                user={auth}
                currentRecipient={sendTo}
                readonly={false}
              />
            )}
          </div>
        </Drawer>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(MessageDrawer);



// WEBPACK FOOTER //
// ./src/components/shared/components/MessageDrawer.js